import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Galeria from "./components/Galeria";
import Financiamento from "./components/Financiamento";
import Beneficios from "./components/Beneficios";
import ProvasSocial from "./components/ProvasSocial";
import Sobre from "./components/Sobre";
import Diferenciais from "./components/Diferenciais";
import Footer from "./components/Footer";
import TrabalheConosco from "./components/TrabalheConosco";

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />
      <Hero />
      <Galeria />
      <Financiamento />
      <Beneficios />
      <ProvasSocial />
      <Sobre />
      <Diferenciais />
      <TrabalheConosco />
      <Footer />
    </div>
  );
}
